(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-detail"] && !Shopify.designMode) return;
  try {
    
  const loadDeferredVideo = (video) => {
    if (video.dataset.deferredVideoLoaded === "true") return;

    video.querySelectorAll("source[data-src]").forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute("data-src");
    });
    video.dataset.deferredVideoLoaded = "true";
    video.load();
  };

  const playDeferredVideo = async (video, playButton) => {
    loadDeferredVideo(video);

    try {
      await video.play();
      if (playButton) playButton.hidden = true;
    } catch (error) {
      if (playButton) playButton.hidden = false;
    }
  };

  const initializeProductMediaBanners = (root = document) => {
    root.querySelectorAll("[data-product-media-banner]").forEach((section) => {
      const playButton = section.querySelector("[data-deferred-video-play]");
      const video = section.querySelector("[data-deferred-video]");

      if (!video || video.dataset.deferredVideoBound === "true") return;

      video.dataset.deferredVideoBound = "true";
      playButton?.addEventListener("click", () => playDeferredVideo(video, playButton));

      const shouldAutoplay = video.dataset.deferredVideoAutoplay === "true";
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (!shouldAutoplay || reducedMotion) {
        if (playButton) playButton.hidden = false;
        return;
      }

      if (!("IntersectionObserver" in window)) {
        if (playButton) playButton.hidden = false;
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        observer.disconnect();
        playDeferredVideo(video, playButton);
      }, { rootMargin: "240px 0px" });

      observer.observe(section);
    });
  };

  initializeProductMediaBanners();

  const initializeProductReviewsSummary = (root = document) => {
    root.querySelectorAll(".product-reviews-section .jdgm-rev-widg").forEach((widget) => {
      const averageLink = widget.querySelector(".jdgm-rev-widg__summary-average .jdgm-link");
      const averageText = averageLink?.textContent?.trim();
      const ratingMatch = averageText?.match(/\d+(?:[.,]\d+)?/);

      if (!averageLink || averageLink.dataset.productReviewsSummaryNormalized === "true" || !ratingMatch) return;

      const rating = Number.parseFloat(ratingMatch[0].replace(",", "."));

      if (!Number.isFinite(rating)) return;

      averageLink.textContent = rating.toFixed(1);
      averageLink.setAttribute("aria-label", averageText);
      averageLink.dataset.productReviewsSummaryNormalized = "true";
    });
  };

  const initializeProductReviewsOtherLanguages = (root = document) => {
    root.querySelectorAll(".product-reviews-section .jdgm-rev-widg").forEach((widget) => {
      const primaryReviews = widget.querySelector(":scope > .jdgm-rev-widg__body .jdgm-rev-widg__primary-content > .jdgm-rev-widg__reviews, :scope > .jdgm-rev-widg__body > .jdgm-rev-widg__reviews, :scope .jdgm-rev-widg__primary-content > .jdgm-rev-widg__reviews");
      const otherLanguageBlocks = widget.querySelectorAll(".jdgm-rev-widg__other-lang");

      if (!primaryReviews || !otherLanguageBlocks.length) return;

      otherLanguageBlocks.forEach((block) => {
        const otherLanguageReviews = block.querySelectorAll(".jdgm-rev-widg__reviews > .jdgm-rev");

        otherLanguageReviews.forEach((review) => {
          review.dataset.productReviewsLanguageMerged = "true";
          primaryReviews.append(review);
        });

        if (!block.querySelector(".jdgm-rev-widg__reviews > .jdgm-rev")) {
          block.classList.add("is-product-reviews-merged");
          block.hidden = true;
        }
      });
    });
  };

  const initializeProductReviews = (root = document) => {
    initializeProductReviewsSummary(root);
    initializeProductReviewsOtherLanguages(root);

    const reviewSections = [];

    if (root.matches?.("[data-product-reviews-block]")) {
      reviewSections.push(root);
    }

    root.querySelectorAll?.("[data-product-reviews-block]").forEach((section) => {
      reviewSections.push(section);
    });

    reviewSections.forEach((section) => {
      if (section.dataset.productReviewsObserverBound === "true") return;

      section.dataset.productReviewsObserverBound = "true";

      const observer = new MutationObserver(() => {
        initializeProductReviewsSummary(section);
        initializeProductReviewsOtherLanguages(section);
      });

      observer.observe(section, { childList: true, subtree: true });
    });
  };

  initializeProductReviews();

  document.addEventListener("shopify:section:load", (event) => {
    initializeProductMediaBanners(event.target);
    initializeProductReviews(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
